module.exports = __webpack_public_path__ + "static/img/5.7a9247d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/5.png
// module id = ToqF
// module chunks = 5